import React from 'react'
import './Contact.scss'
import { useForm, ValidationError } from '@formspree/react';

const  Contact = () => {
  const [state, handleSubmit] = useForm("mpzegwwj");
  if (state.succeeded) {
    var name = document.getElementById("name");
    name.value = "";
    var email = document.getElementById("email");
    email.value = "";
    var subject = document.getElementById("subject");
    subject.value = "";
    var message = document.getElementById("message");
    message.value = "";

  }
  return (
    <div className='contact-all'>
        <div className='contact-page'>
            <div className='contact-page-left' style={{color:'var(--darkgray-color)'}} data-aos="fade-right">
                <h1>Get</h1>
                <h2>in</h2>
                <h3>touch.</h3>
                <p>We can work together. Feel free to send me any message!</p>
            </div>
            <form onSubmit={handleSubmit} className='contact-page-form' id='contact' data-aos="fade-left">
                <input
                    placeholder='Name'
                    id="name"
                    type="name" 
                    name="name"
                    required="required"
                />
                <ValidationError 
                    prefix="Name" 
                    field="name"
                    errors={state.errors}
                />
                <input
                    placeholder='E-mail'
                    id="email"
                    type="email" 
                    name="email"
                    required="required"
                />
                <ValidationError 
                    prefix="Email" 
                    field="email"
                    errors={state.errors}
                />
                <input
                    placeholder='Subject'
                    id="subject"
                    type="subject" 
                    name="subject"
                    required="required"
                />
                <ValidationError 
                    prefix="Subject" 
                    field="subject"
                    errors={state.errors}
                />
                <textarea
                    placeholder='Message'
                    id="message"
                    name="message"
                    required="required"
                    rows="6"
                    
                />
                <ValidationError 
                    prefix="Message" 
                    field="message"
                    errors={state.errors}
                />
                <div className='contact-submit'>
                    <div className='contact-submit-circle'/>
                    <button type="submit" disabled={state.submitting}>SUBMIT</button>
                    <i class="fas fa-sharp fa-solid fa-chevron-right"></i>
                </div>
            </form>
        </div>
        <div className='contact-page-lower'>
            <p>@HENNING YANG 2023</p>
            <hr/>
            <a href="https://www.instagram.com/henning_0908/"><i class="fab fa-instagram"></i></a>
            <a href="https://www.facebook.com/henning.yang"><i class="fab fa-facebook"></i></a>
            <a href="https://www.linkedin.com/in/珩-楊-41314b254/"><i class="fab fa-linkedin"></i></a>
            <a href="https://github.com/HenningY"><i class="fab fa-github"></i></a>
            <a href="https://www.behance.net/68aeeeeb"><i class="fab fa-behance-square"></i></a>
        </div>
    </div>
  )
}

export default Contact